import Api from '@/services/Api'

export default {
	getPage(pageIdentifier = '__HOMEPAGE__') {
		return Api().get(`page/${pageIdentifier}`)
	},
	getPages(textSearch = '') {
		const encodedTextSearch = textSearch ? encodeURIComponent(textSearch) : '';
		return Api().get(`pages?q=${encodedTextSearch}`)
	},
	updatePageContent(pageObj) {
		return Api().put(`page/${pageObj.guid}`, pageObj)
	},
	getPageHistory(pageIdentifier = '__HOMEPAGE__') {
		return Api().get(`page/${pageIdentifier}/history`)
	},
	getPageRevision(pageIdentifier, rev) {
		return Api().get(`page/${pageIdentifier}/history/${rev}`)
	},
	createPage(title) {
		return Api().post(`pages`, { title });
	},
	deletePage(pageIdentifier) {
		return Api().delete(`page/${pageIdentifier}`)
	},
	restorePage(pageIdentifier, revision) {
		return Api().post(`page/${pageIdentifier}/history`, { revision })
	},
	uploadAttachment(pageIdentifier, attachmentFile) {
		const formData = new FormData()
		formData.append('attachment', attachmentFile)

		return Api().post(`page/${pageIdentifier}/attachments`, formData, {
			headers: { 'Content-Type': 'multipart/form-data' }
		})
	}
}
